import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Informacoes from '@/views/escritorios/Informacoes'
import AbaEndereco from '@/views/escritorios/AbaEndereco'
import Contato from '@/views/escritorios/Contato'
import { mapState, mapActions } from 'vuex'
import mensagens from '@/util/mensagens'
import { BAlert, BSpinner } from 'bootstrap-vue'
import util from '@/util'
import cnpj from '@/util/cnpj'
import cpf from '@/util/cpf'
import { valorEhCpf, valorEhCnpj } from '@/util/index'
import cadastroUtil from '@/util/cadastroUtil'

export default {
  name: 'edicao-escritorio-usuario',
  components: {
    cabecalho,
    Informacoes,
    AbaEndereco,
    Contato,
    menuLateral,
    'b-alert': BAlert,
    'b-spinner': BSpinner
  },

  computed: {
    ...mapState('escritorios', ['formulario', 'dadosRetorno', 'flagsDeControle', 'listaUsuariosRepresentanteLegal']),
    desabilitarCampos () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    },
    ehPessoaFisica () {
      return this.formulario.tipo === 1
    }
  },

  data: () => {
    return {
    }
  },

  async mounted () {
    this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
    this.ActionResetarDadosRetornoCadastro()
    this.ActionResetarDadosFormularioEscritorio()
    let { id: idEscritorio } = this.$route.params

    if (util.valorEhNulo(idEscritorio)) {
      await this.redirecionarEdicaoEscritorioUsuarioLogado()
    }

    idEscritorio = this.$route.params.id
    if (!util.valorEhNulo(idEscritorio)) {
      await this.obterEscritorio(idEscritorio)
    }
    this.limparFlagErroNoFormulario()

    this.definirFlagCarregandoDados(false)
  },

  methods: {
    ...mapActions('escritorios', [
      'ActionResetarDadosFormularioEscritorio',
      'ActionSalvarEscritorio',
      'ActionObterEscritorio',
      'ActionResetarDadosRetornoCadastro'
    ]),

    async redirecionarEdicaoEscritorioUsuarioLogado () {
      try {
        const { escritorio } = await this.obterDadosUsuarioLogado()
        this.$router.replace({ name: 'edicao-escritorio-usuario', params: { id: escritorio } })
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },

    async obterDadosUsuarioLogado () {
      const resposta = await this.axios.get('/manager/conta/usuarios/usuario')
      const dadosResposta = resposta.data.retorno.dados
      return {
        escritorio: dadosResposta.empresa_id
      }
    },

    async salvarRegistro () {
      const validacaoOk = this.validarDadosFormulario()
      if (validacaoOk) {
        await this.executarSalvarRegistro()
      }
    },
    async buscarInformacoesDoCnpj (cnpj) {
      try {
        const retorno = await this.axios.get(`/manager/conta/consultar/cnpj/${cnpj}`)
        return retorno.data
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async obterEscritorio (id) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        await this.ActionObterEscritorio(id)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    obterDadosFormularioInformacoesAdicionais () {
      if (this.ehPessoaFisica) {
        return util.mapearObjetos(this.formulario.informacoes.pessoais, {})
      }

      return util.mapearObjetos(this.formulario.informacoes.empresariais, {})
    },
    validarDadosFormulario () {
      this.ActionResetarDadosRetornoCadastro()
      const formulario = this.tratarDadosFormulario()
      if (util.valorVazio(formulario.cpf_cnpj)) {
        this.dadosRetorno.listaDeErros['cpf_cnpj'] = 'Este campo é obrigatório'
      }

      if (this.ehPessoaFisica && !valorEhCpf(formulario.cpf_cnpj)) {
        this.dadosRetorno.listaDeErros['cpf_cnpj'] = 'O campo CPF é inválido.'
      }
      if (!this.ehPessoaFisica && !valorEhCnpj(formulario.cpf_cnpj)) {
        this.dadosRetorno.listaDeErros['cpf_cnpj'] = 'O campo CNPJ é inválido.'
      }

      if (this.dadosRetorno.listaDeErros['phone'] === 'Este campo é obrigatório') {
        this.dadosRetorno.listaDeErros['phone'] = 'O campo Telefone é obrigatório'
      }

      const validacaoOk = Object.values(this.dadosRetorno.listaDeErros).length === 0
      return validacaoOk
    },

    tratarDadosFormularioInformacoes () {
      const dadosFormularioInformacoes = util.mapearObjetos(this.formulario.informacoes, {})
      const dadosFormularioInformacoesAdicionais = this.obterDadosFormularioInformacoesAdicionais()

      return {
        observacoes: dadosFormularioInformacoes.observacoes,
        logotipo: dadosFormularioInformacoes.logotipo,
        endereco_logotipo: dadosFormularioInformacoes.endereco_logotipo,
        ...dadosFormularioInformacoesAdicionais
      }
    },

    tratarDadosFormulario () {
      const dadosFormularioEndereco = util.mapearObjetos(this.formulario.endereco, {})
      const dadosFormularioContato = util.mapearObjetos(this.formulario.contato, {})
      const dadosFormularioInformacoes = this.tratarDadosFormularioInformacoes()

      let dadosFormulario = {
        id: this.formulario.id,
        tipo: this.formulario.tipo,
        ...dadosFormularioInformacoes,
        ...dadosFormularioEndereco,
        ...dadosFormularioContato
      }
      dadosFormulario.data_nascimento = util.formatarData(dadosFormulario.data_nascimento, 'DD/MM/YYYY')
      // dadosFormulario.representante_legal = cadastroUtil.obterCodigoCombo({ campo: dadosFormulario.representante_legal })
      dadosFormulario.uf = cadastroUtil.obterCodigoCombo({ campo: dadosFormulario.uf })
      dadosFormulario.cep = util.apenasNumeros(dadosFormulario.cep)
      dadosFormulario.celular = util.apenasNumeros(dadosFormulario.celular)
      dadosFormulario.fone = util.apenasNumeros(dadosFormulario.fone)
      this.aplicarDocumentoNormalizadoCadastro(dadosFormulario)

      return dadosFormulario
    },

    aplicarDocumentoNormalizadoCadastro (dadosFormulario) {
      const documentoFederalInformadoNoFormulario = dadosFormulario.cpf_cnpj
      const documentoFederalNormalizadoParaPersistencia = this.normalizarDocumentoCadastro(documentoFederalInformadoNoFormulario)
      dadosFormulario.cpf_cnpj = documentoFederalNormalizadoParaPersistencia
    },

    normalizarDocumentoCadastro (valor) {
      if (this.ehPessoaFisica) {
        return cpf.normalizarCpf(valor)
      }

      return cnpj.normalizarCnpj(valor)
    },

    async executarSalvarRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        const dadosFormulario = this.tratarDadosFormulario()
        const formData = this.montarObjetoDeEnvio(dadosFormulario)
        await this.ActionSalvarEscritorio(formData)

        this.limparFlagErroNoFormulario()
        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    montarObjetoDeEnvio (dadosFormulario) {
      const formData = new FormData()
      const campos = Object.entries(dadosFormulario)
      const logotipo = ['logotipo']
      const camposIgnorados = [...logotipo, 'tipo']

      for (let [chave, valor] of campos) {
        if (!camposIgnorados.includes(chave)) {
          formData.append(chave, valor)
        }
        if (logotipo.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave, valor, valor.nome)
        }
      }
      return formData
    },

    tratarAposSalvarRegistro () {
      this.flagsDeControle.avisoDeErroNoFormulario = util.obterDadosAlertaAposSalvarRegistro(this.dadosRetorno)
      if (!this.flagsDeControle.avisoDeErroNoFormulario.exibir) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
      }
    },
    voltar () {
      this.$router.back()
    },

    definirFlagErroNoFormulario (status, mensagem) {
      this.flagsDeControle.avisoDeErroNoFormulario.exibir = status
      this.flagsDeControle.avisoDeErroNoFormulario.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    limparFlagErroNoFormulario () {
      this.definirFlagErroNoFormulario(false, '')
    }
  }
}
